module.exports = __webpack_public_path__ + "img/botoneria.251a4a29.png";